import { Box, Button, Flex } from 'app/components/design-system-components'
import HeadingAndLabel from 'app/components/display/smartdocs/headingAndLabel'
import theme from 'app/match/applicationReportPDF/assets/theme'
import { getPageIDByIndexInTargetSectionObject } from 'app/sm/helpers'

export interface CopilotDataProps {
  copilot: string
  copilot_type: string
  target_section: string
  title: string
}

export interface ExplainerCopilotProps {
  copilotData?: CopilotDataProps[] | null | undefined
  onClickView?: () => void
  fromSummary?: boolean
}

function ExplainerCopilot({
  copilotData,
  onClickView,
  fromSummary = true,
}: ExplainerCopilotProps) {
  return (
    <Box width="100%">
      {copilotData?.map(({ copilot, copilot_type, target_section, title }) => {
        const targetSectionPageID =
          getPageIDByIndexInTargetSectionObject(target_section)
        return (
          <Box mb={4} lineHeight="140%">
            <HeadingAndLabel
              heading={title}
              status={copilot_type}
              isCopilot={true}
            />
            <Box fontSize={theme.fontSizes.pRegular14} mb={3} mt={1}>
              {copilot}
            </Box>
            <Button variant="outlineGray" sizeVariant="extraSmall">
              <Flex alignItems="center">
                <Box
                  onClick={() => {
                    if (fromSummary) {
                      const element =
                        window.document.getElementById(targetSectionPageID)
                      if (element) {
                        element.scrollIntoView({ behavior: 'smooth' })
                      }
                    } else {
                      if (onClickView) {
                        onClickView()
                      }
                    }
                  }}
                >
                  View
                </Box>
              </Flex>
            </Button>
          </Box>
        )
      })}
    </Box>
  )
}

export default ExplainerCopilot
